import script from "./Chrome.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chrome.vue?vue&type=script&setup=true&lang=ts"

import "./Chrome.vue?vue&type=style&index=0&id=17a953a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a953a8"]])

export default __exports__